export const VISITS_FILTER = 'VisitsFilter';
export const CLIENTS_FILTER = 'ClientsFilter';
